import { Container } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import {
    EmptyListMessage,
    EndOfInfiniteListMessage,
    PageHeader,
    Spinner,
} from "../../../../components/exports";
import ScrollToTop from "../../../../components/shared/ScrollToTop";
import ViewPreference from "../../../../components/shared/ViewPreference";
import { FetchSmsListQueryType } from "../../api-hooks/smsCampaignQuery";
import SmsCampaignListDesktop from "../../components/SmsCampaignListDesktop";
import SmsCampaignListMobile from "../../components/SmsCampaignListMobile";

type TProps = {
    queryData: FetchSmsListQueryType;
    isLargeScreen: boolean;
    preferDesktop: boolean;
    preferDesktopChange: (preferDesktop: boolean) => void;
};

// updated
export default function SmsCampaignList({
    isLargeScreen,
    queryData,
    preferDesktop,
    preferDesktopChange,
}: TProps) {
    return (
        <Container maxWidth="xl">
            <PageHeader
                title="لیست کمپین های پیامکی"
                action={
                    <ViewPreference
                        preferDesktop={preferDesktop}
                        onChange={preferDesktopChange}
                    />
                }
            />

            {queryData.firstTimeLoading && <Spinner />}

            {queryData.count === 0 && (
                <EmptyListMessage message="کمپین پیامکی یافت نشد" />
            )}

            {queryData.data && queryData.data.length > 0 && (
                <InfiniteScroll
                    dataLength={queryData.count}
                    next={() => {
                        queryData.fetchMore();
                    }}
                    hasMore={queryData.hasMore}
                    loader={<Spinner />}
                    endMessage={<EndOfInfiniteListMessage />}
                >
                    {isLargeScreen && preferDesktop ? (
                        <SmsCampaignListDesktop smsCampaigns={queryData.data} />
                    ) : (
                        <SmsCampaignListMobile smsCampaigns={queryData.data} />
                    )}
                </InfiniteScroll>
            )}

            <ScrollToTop />
        </Container>
    );
}
